import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '../../material.module';
import { EditorSharedModule } from '../shared/components/editor-shared';
import { CKEditorModule } from '../ckeditor/ckeditor.module';
import { WkKeywordEditorComponent } from './wk-keyword-editor';
import { WkDefinitionEditorComponent } from './wk-definition-editor';
import { WkAddKeywordAndDefinitionComponent } from './keyword-and-definition';
import { WkKeywordComponent } from './wk-keyword/wk-keyword.component';
import { SafeHtmlPipe } from '../shared/pipes';

const components = [
  WkDefinitionEditorComponent,
  WkKeywordEditorComponent,
  WkAddKeywordAndDefinitionComponent,
  WkKeywordComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MaterialModule,
    EditorSharedModule,
    TranslateModule,
    CKEditorModule,
    FormsModule,
    SafeHtmlPipe,
  ],
  exports: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WkKeywordModule {}
